// react
import React from "react";
// components
import ProfileLanguage from "./ProfileLanguage";
import ProfileChangePassword from "./ProfileChangePassword";
import ProfileNickname from "./ProfileNickname";
import ProfileActivation from "./ProfileActivation";
import ProfileSocialNetworks from "./ProfileSocialNetworks";
import ProfileAddress from "./ProfileAddress";
import ProfileSharedAccess from "./ProfileSharedAccess";
import { Tab } from "semantic-ui-react";

// panes
// eslint-disable-next-line
const paneLanguage = {
    menuItem: {
        key: "language",
        content: "Jazyk",
        icon: "language",
    },
    render: () => (
        <Tab.Pane>
            <ProfileLanguage />
        </Tab.Pane>
    ),
};

const panePassword = {
    menuItem: { key: "change_password", content: "Heslo", icon: "key" },
    render: () => (
        <Tab.Pane>
            <ProfileChangePassword />
        </Tab.Pane>
    ),
};

const paneNickname = {
    menuItem: {
        key: "nickname",
        content: "Prezývka",
        icon: "user",
    },
    render: () => (
        <Tab.Pane>
            <ProfileNickname />
        </Tab.Pane>
    ),
};

const paneSocialNetworks = {
    menuItem: {
        key: "social",
        content: "Sociálne siete",
        icon: "globe",
    },
    render: () => (
        <Tab.Pane>
            <ProfileSocialNetworks />
        </Tab.Pane>
    ),
};

const paneActivation = {
    menuItem: {
        key: "activation_state",
        content: "Deaktivácia",
        icon: "user delete",
    },
    render: () => (
        <Tab.Pane>
            <ProfileActivation />
        </Tab.Pane>
    ),
};

const paneSharedAccess = {
    menuItem: {
        key: "shared_access",
        content: "Vzdialený prístup",
        icon: "share alternate",
    },
    render: () => (
        <Tab.Pane>
            <ProfileSharedAccess />
        </Tab.Pane>
    ),
};

const paneProfile = {
    menuItem: {
        key: "profile",
        content: "Profil",
        icon: "user",
    },
    render: () => (
        <Tab.Pane>
            <ProfileAddress />
        </Tab.Pane>
    ),
};

// profile settings admin
export const adminPanes = [/*paneLanguage,*/ panePassword];

// profile settings provider
export const providerPanes = [
    paneNickname,
    paneSocialNetworks,
    //paneLanguage,
    paneSharedAccess,
    panePassword,
    paneActivation,
];

export const providerPanesForAdmin = [paneNickname, paneSocialNetworks];

export const providerPanesForManagedAccess = [
    paneSharedAccess,
    panePassword,
    paneActivation,
];

// profile settings client
export const userPanes = [paneProfile, panePassword];
